module.exports = __webpack_public_path__ + "static/media/XVIIIe.aedbfa3e.png";